module.exports = __webpack_public_path__ + "Raleway-500-Medium.430a0518f5ff3b6c8968.ttf";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/assets/fonts/Raleway-500-Medium.ttf
// module id = ../../../../../src/assets/fonts/Raleway-500-Medium.ttf
// module chunks = styles